import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import * as moment from 'moment';
import { reactI18nextModule } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import pt from 'react-intl/locale-data/pt';
import es from 'react-intl/locale-data/es';
import zh from 'react-intl/locale-data/zh';

addLocaleData([...en, ...pt, ...es, ...zh]);

const detection = {
  lookupLocalStorage: 'language',
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    load: 'languageOnly',
    fallbackLng: 'en',
    debug: false,
    ns: ['translation'],
    defaultNS: 'translation',
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    detection,
    react: {
      wait: true,
      bindStore: false,
      bindI18n: 'languageChanged',
    },
  });

export const locale = i18n.services.languageDetector.detectors.localStorage.lookup(detection);

export const t = (str, options) => i18n.t(str, options);

export const modifyLanguage = (lng) => {
  i18n.changeLanguage(lng);
  moment.locale(lng);
};

export default i18n;
